const EMPTY_VALUE = null;
export {
  EMPTY_VALUE
};
//# sourceMappingURL=empty-values.js.map
